import { ApolloError } from '@apollo/client';

export const PEN_UNAVAILABLE_ERROR_CODE = 'PEN_UNAVAILABLE';
export const JURISDICTION_NOT_FOUND_ERROR_CODE = 'JURISDICTION_NOT_FOUND';
export const JURISDICTION_UPSTREAM_ERROR_CODE = 'JURISDICTION_UPSTREAM_ERROR';

export const hasGraphqlErrorCode = (error: unknown, code: string): boolean => {
  if (!(error instanceof ApolloError)) {
    return false;
  }
  return error.graphQLErrors.some((e) => e.extensions?.code === code);
};
